import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-173726ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-main" }
const _hoisted_2 = {
  key: 0,
  class: "tab-bar"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, null, {
      default: _withCtx(() => [
        (_ctx.$slots.default)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
              (_ctx.title)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.title), 1))
                : _createCommentVNode("", true),
              _createVNode(_TransitionGroup, { name: "tabar" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$slots.default().filter(item => item.props), (child, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: 'bc-tab-' + this.tabId + '-' + child.props?.name,
                      onClick: ($event: any) => (_ctx.tabSelect(index)),
                      class: _normalizeClass(_ctx.selectIndex == index ? 'select': '')
                    }, [
                      (child.props?.icon)
                        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                            key: 0,
                            icon: child.props.icon
                          }, null, 8, ["icon"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(child.props?.name), 1)),
                      (index == _ctx.$slots.default().filter(item => item.props).length - 1)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            style: _normalizeStyle(_ctx.getTabLineStyle(index))
                          }, null, 4))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_4))
                  }), 128))
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      class: "tab-body",
      id: 'bc-tab-' + _ctx.tabId
    }, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 8, _hoisted_6)
  ]))
}